import React, { useContext } from "react";
import { SourceSelector } from "@me8eon/source_selector-new";
import { useAgentSelector } from "@me8eon/react_intent";
import styles from "./AgentChip.module.scss";
import { Icon } from "@me8eon/icons";
import { AiAssistContext } from "../../../../components/ai-assist-refactored/AiAssist.context";

export const AgentSelectorTextAreaPlugin: React.FC<{ isBottom?: boolean }> = ({ isBottom }) => {
    const { selectableAgents, selectedAgent, selectAgent } = useAgentSelector();
    const { setCurrentAgent } = useContext(AiAssistContext);

    const sources = selectableAgents.map((agent) => ({
        id: agent.name,
        name: agent.displayName,
        description: agent.description ?? "",
    }));

    const selectedAgentId = selectedAgent ? selectedAgent.name : "";

    const setSelectedAgentById = (selection: string | undefined) => {
        if (!selection) return;
        const agent = selectableAgents.find((a) => a.name === selection);
        if (agent) selectAgent(agent);
        setCurrentAgent(selection);
    };

    const handleClear = (e: React.MouseEvent) => {
        e.stopPropagation();
        selectAgent(undefined);
        setCurrentAgent("");
    };

    return (
        <div
            style={{ display: "flex", flexDirection: "row", alignItems: "center", justifyContent: "center", gap: "8px" }}>
            <SourceSelector
                sources={sources}
                setSelectedSource={setSelectedAgentById}
                selectedSource={selectedAgentId}
                top={!isBottom}
            />

            {selectedAgent && (
                <div key={selectedAgent.name} className={styles.chipContainer}>
                    <span>{selectedAgent.displayName}</span>
                    <div>
                        <button
                            className={styles.closeButton}
                            onClick={handleClear}
                            title="Clear selected agent"
                        >
                            <Icon name="close" />
                        </button>
                    </div>
                </div>
            )}
        </div>
    );
};